'use client';
import RichText, { RichTextContent } from '../../../RichText';
import { SxProps } from '@mui/material';

type Props = {
  title?: RichTextContent;
  sx?: SxProps;
};

const Subtitles = ({ title, sx }: Props) => {
  return (
    <RichText
      withTypography
      color={'textPrimary'}
      variant="h6"
      component="p"
      sx={{ alignSelf: 'end', maxWidth: '300px', ...sx }}
    >
      {title}
    </RichText>
  );
};

export default Subtitles;
